export const palette = {
  white: '#FFFFFF',

  // Soft Colors
  softGray: '#F9FAFB',
  verySoftViolet: '#A78BFA',
  softViolet: '#9475e1',
  softBlue: '#667eea',
  softOrange: '#fbd89d',

  // Light colors
  veryLightGray: '#F3F4F6',
  lightGray: '#E5E7EB',
  coolGray: '#6B7280',
  lightGrayViolet: '#f4eefd',
  /** Right panel (web) and content area above bottom nav (mobile) */
  panelBackground: '#f4f5fa',
  lightBlack: '#121212',
  lightRed: '#FEF2F2',
  lightOrange: '#F59E0B',
  lightGrayishBlue: '#DBEAFE',
  lightVividOrange: '#D97706',

  // Bright colors
  brightViolet: '#7C3AED',
  indigoViolet: '#6366F1',
  mediumViolet: '#8B5CF6',
  /** Outline purple / accent (e.g. Use My Palette button, heart icon) */
  outlinePurple: '#7837E9',
  outlinePurpleLight: 'rgba(120, 55, 233, 0.08)',
  outlinePurpleSoft: 'rgba(120, 55, 233, 0.12)',
  brightRed: '#DC2626',
  brightMatteRed: '#EF4444',
  brightBlue: '#3B82F6',

  // Medium colors
  mediumGray: '#9CA3AF',
  mediumGray2: '#4B5563',
  mediumGray3: '#9E9E9E',

  // Dark colors
  darkGray: '#374151',
  darkGrayBlue: '#6B7280',
  veryDarkBlue: '#1F2937',
  darkModerateViolet: '#764ba2',

  // Green
  lightCyanGreen: '#D1FAE5',
  cyanLimeGreen: '#10B981',
  stongCyanLimeGreen: '#34D399',
  darkCyanLimeGreen: '#059669',
  brightCyanLimeGreen: '#6ff2c7',
  brightGreen: '#22C55E',

  // Vivid
  vividLightOrange: '#FBBF24',
  vividOrange: '#EA580C',
  vividBlue: '#2196f3',
  vividYellow: '#FFC107',
  colorGeneratorYellow: '#FFB703',

  // Cyan
  strongCyan: '#06B6D4',

  //Blue
  verySoftBlue: '#93C5FD',

  // Pink
  softPink: '#EC4899',
  darkPink: '#DB2777',

  // Gradient Colors
  gradientPink: '#F3E7E9',
  gradientBlue: '#E3EEFF',
};
